import { render, staticRenderFns } from "./subdepartments.vue?vue&type=template&id=4f9e8487&"
import script from "./subdepartments.vue?vue&type=script&lang=js&"
export * from "./subdepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports